import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Logo from "../images/logo1.png";
import Placeholder from "../images/placeholder.jpg";

import layout from "../css/landing.module.css";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import styles from "../css/members.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faHouse, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

function AddMemberKharis() {
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(Placeholder);
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [latestId, setLatestId] = useState("");

  const [formData, setFormData] = useState({
    church_id: "",
    first_name: "",
    last_name: "",
    other_name: "",
    mobile_num: "",
    area: "",
    housenum: "",
    landmark: "",
    digital_add: "",
    hometown: "",
    region: "",
    pbox: "",
    email: "",
    dob: "",
    occupation: "",
    employer: "",
    work_address: "",
    work_contact_num: "",
    office_location: "",
    marital_status: "",
    marriage_type: "",
    spouse_name: "",
    children: "",
    department: "",
    service_type: "",
    date_joined: "",
  });

  // AUTO GENERATE CHURCH ID 
  useEffect(() => {
    axios
      .get("https://appserver.cemkharistemple.com/getLatestId")
      .then((res) => {
        const id = res.data.latestId || "";
        setLatestId(id);
        setFormData((prev) => ({ ...prev, church_id: id }));
      })
      .catch((err) => console.error(err));
  }, []);

  // VALIDATION 
  const validate = (data) => {
    const e = {};

    // required
    if (!data.first_name?.trim()) e.first_name = "First Name is required";
    if (!data.last_name?.trim()) e.last_name = "Last Name is required";
    if (!data.mobile_num?.trim()) e.mobile_num = "Mobile Number is required";
    if (!data.date_joined?.trim()) e.date_joined = "Date Joined is required";
    if (!data.department?.trim()) e.department = "Department is required";
    if (!data.service_type?.trim()) e.service_type = "Preferred Service is required";

    const digits = (data.mobile_num || "").replace(/\D/g, "");
    if (data.mobile_num && digits.length < 9) e.mobile_num = "Invalid mobile number";

    if (data.email?.trim()) {
      const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim());
      if (!ok) e.email = "Invalid email address";
    }

    return e;
  };

  // ANDLE INPUT 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const next = { ...prev, [name]: value, church_id: latestId || prev.church_id };
      return next;
    });

    // live clear error
    setErrors((prev) => {
      if (!prev[name]) return prev;
      const copy = { ...prev };
      delete copy[name];
      return copy;
    });
  };

  //  HANDLE IMAGE 
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) setImagePreview(URL.createObjectURL(file));
  };

  //  HANDLE SUBMIT 
  const handleSubmit = async (e) => {
    e.preventDefault();

    const v = validate(formData);
    if (Object.keys(v).length) {
      setErrors(v);
      return;
    }

    setLoading(true);
    try {

      const res = await axios.post(
        "https://appserver.cemkharistemple.com/savenewmember",
        { value: formData }
      );

      if (res.data?.message === "Success") {
        setSuccessModal(true);
      } else {
        setErrors({ form: "Details not saved. Please try again." });
      }
    } catch (err) {
      console.error(err);
      setErrors({ form: "Server error. Please try again." });
    }
    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <div className={layout.container}>
      {/*  HEADER  */}
      <Topbar title="Add Member" subtitle="Register new Kharis Temple member" />

      {/*  SIDEBAR  */}
      <Sidebar variant="kharis" />

      {/*  MAIN  */}
      <main className={layout.main}>
        <div className={styles.wrapper}>
          <form onSubmit={handleSubmit} className={styles.formCard}>
            {/* TOP ROW */}
            <div className={styles.topRow}>
              <div className={styles.leftTop}>
                <input
                  type="text"
                  value={latestId}
                  readOnly
                  className={styles.input}
                  placeholder="Church ID"
                />
              </div>

              <div className={styles.profileSection}>
                <img src={imagePreview} alt="Preview" className={styles.profilePreview} />
                <input type="file" onChange={handleImageChange} className={styles.uploadInput} />
              </div>
            </div>

            {errors.form && <div className={styles.errorText}>{errors.form}</div>}

            {/* PERSONAL INFO */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Personal Information</div>
              <div className={styles.formGrid}>
                <div>
                  <input name="first_name" placeholder="First Name" className={styles.input} onChange={handleChange} />
                  {errors.first_name && <div className={styles.errorText}>{errors.first_name}</div>}
                </div>

                <div>
                  <input name="last_name" placeholder="Last Name" className={styles.input} onChange={handleChange} />
                  {errors.last_name && <div className={styles.errorText}>{errors.last_name}</div>}
                </div>

                <input name="other_name" placeholder="Other Name" className={styles.input} onChange={handleChange} />

                <div>
                  <input name="mobile_num" placeholder="Mobile Number" className={styles.input} onChange={handleChange} />
                  {errors.mobile_num && <div className={styles.errorText}>{errors.mobile_num}</div>}
                </div>

                <input name="area" placeholder="Area Of Residence" className={styles.input} onChange={handleChange} />
                <input name="housenum" placeholder="House Number" className={styles.input} onChange={handleChange} />
                <input name="landmark" placeholder="Nearest Landmark" className={styles.input} onChange={handleChange} />
                <input name="digital_add" placeholder="Digital Address" className={styles.input} onChange={handleChange} />
                <input name="hometown" placeholder="Hometown" className={styles.input} onChange={handleChange} />
                <input name="region" placeholder="Region" className={styles.input} onChange={handleChange} />
                <input name="pbox" placeholder="Mailing Address" className={styles.input} onChange={handleChange} />

                <div>
                  <input name="email" placeholder="Email Address" className={styles.input} onChange={handleChange} />
                  {errors.email && <div className={styles.errorText}>{errors.email}</div>}
                </div>

                <input name="dob" placeholder="Date of Birth" className={styles.input} onChange={handleChange} />
              </div>
            </div>

            {/* EMPLOYMENT */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Employment Information</div>
              <div className={styles.formGrid}>
                <input name="occupation" placeholder="Occupation" className={styles.input} onChange={handleChange} />
                <input name="employer" placeholder="Employer" className={styles.input} onChange={handleChange} />
                <input name="work_address" placeholder="Work Address" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
                <input name="work_contact_num" placeholder="Work Contact Number" className={styles.input} onChange={handleChange} />
                <input name="office_location" placeholder="Office Location" className={styles.input} onChange={handleChange} />
              </div>
            </div>

            {/* FAMILY */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Family Information</div>
              <div className={styles.formGrid}>
                <input name="marital_status" placeholder="Marital Status" className={styles.input} onChange={handleChange} />
                <input name="marriage_type" placeholder="Marriage Type" className={styles.input} onChange={handleChange} />
                <input name="spouse_name" placeholder="Spouse Name" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
                <input name="children" placeholder="Children (Names & DOB)" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
              </div>
            </div>

            {/* DEPARTMENT */}
            <div className={styles.sectionBlock}>
              <div className={styles.sectionTitle}>Department & Others</div>
              <div className={styles.formGrid}>
                <div>
                  <input name="department" placeholder="Department" className={styles.input} onChange={handleChange} />
                  {errors.department && <div className={styles.errorText}>{errors.department}</div>}
                </div>

                <div>
                  <input name="service_type" placeholder="Preferred Service" className={styles.input} onChange={handleChange} />
                  {errors.service_type && <div className={styles.errorText}>{errors.service_type}</div>}
                </div>

                <div className={styles.fullWidth}>
                  <input name="date_joined" placeholder="Date Joined" className={`${styles.input} ${styles.fullWidth}`} onChange={handleChange} />
                  {errors.date_joined && <div className={styles.errorText}>{errors.date_joined}</div>}
                </div>
              </div>
            </div>

            {/* ACTIONS */}
            <div className={styles.formActions}>
              <button type="submit" className={styles.primaryBtn} disabled={loading}>
                {loading ? "Saving..." : "Submit Form"}
              </button>

              <button type="button" className={styles.secondaryBtn} onClick={() => navigate("/kharispage")}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </main>

      {/* SUCCESS MODAL */}
      {successModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalBox}>
            <div className={styles.modalTitle}>Member Created </div>
            <div className={styles.modalText}>
              Member registered successfully. An SMS with the Church ID will be sent automatically.
            </div>
            <button className={styles.primaryBtn} onClick={() => navigate("/kharispage")}>
              Go to Members
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddMemberKharis;